export default __webpack_public_path__ + "static/media/chair-1-seat-1-back.2ab91bdc.webp";